import React, { useState } from 'react';
import moment from 'moment';
import { AiOutlineEdit, AiOutlineShareAlt } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { ShareQuoteModal } from '../ShareQuoteModal/ShareQuoteModal';
import { FaShare } from 'react-icons/fa';

function GeoclientQuote({ quoteItem, onQuoteEdit, getQuoteInfo }) {
  const { quote_id, created_at, title: quoteTitle } = quoteItem;
  const title = quoteTitle ? quoteTitle : `Геоподборка ${quote_id}`;

  const [isModalOpened, setModalOpened] = useState(false);
  const [quoteData, setQuoteData] = useState('');

  const [isButtonsOpened, setButtonsOpened] = useState(false);

  function handleButtonsOpened() {
    setButtonsOpened(!isButtonsOpened);
  }

  async function handleModalOpen() {
    const quoteResponseData = await getQuoteInfo(quote_id);
    setQuoteData(quoteResponseData)
    setModalOpened(true);
  }

  function editQuote(quoteId) {
    onQuoteEdit(quoteId);
    handleButtonsOpened();
  }

  function handleShareModalClose() {
    setQuoteData('');
    setModalOpened(false);
  }

  return (
    <>
      {quoteData ? (
        <ShareQuoteModal
          handleClose={handleShareModalClose}
          isOpen={isModalOpened}
          quoteItem={quoteItem}
          quoteData={quoteData}
        />
      ) : null}
      <article className="quotes__item">
        <Link
          to={`http://www.geograftour.com/geoclient/${quote_id}`}
          target="_blank"
          className="quotes__item-container"
        >
          <h4 className="quotes__item-header">{title}</h4>
          <span className="quotes__item-date">
            {moment(created_at).format('DD.MM.YY HH:mm')}
          </span>
        </Link>
        <div className="quotes__item-actions">
          <div className={`quotes__item-btns`}>
            <button
              className="quotes__item-copy-btn quotes__item-btn"
              onClick={handleModalOpen}
              title="Поделиться подборкой"
            >
              <FaShare />
            </button>
            <button
              className="quotes__item-edit-btn quotes__item-btn"
              onClick={() => editQuote(quote_id)}
              title="Редактировать подборку"
            >
              <AiOutlineEdit />
            </button>
          </div>
        </div>
      </article>
    </>
  );
}

export default GeoclientQuote;
